import React, { useEffect } from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"
import { IndexQuery } from "../../types/graphql-types"
import { navigate } from "@reach/router"

export interface IndexPageProps {
  data: IndexQuery
}

const IndexPage: React.FC<IndexPageProps> = props => {
  //Redirect users to app page
  useEffect(() => {
    typeof window !== "undefined" && navigate("/app")
  }, [])

  return (
    <div>
      <SEO title="Home" />
      {/* <Link to="/app">Go to app</Link> */}
    </div>
  )
}

// Queries here are part of gatsbyJS static build process
// Read more at: https://www.gatsbyjs.org/
export const query = graphql`
  query Index {
    site {
      siteMetadata {
        description
      }
    }
  }
`

export default IndexPage
